webpackJsonp([86],{

/***/ 1131:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".SlideWithImage{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.SlideWithImage.left-image{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.SlideWithImage.left-image .slide-img{margin-right:4em}.SlideWithImage.right-image .slide-img{margin-left:4em}.SlideWithImage .slide-img{margin:0}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/contents/SlideWithImage/src/components/contents/SlideWithImage/SlideWithImage.m.scss"],"names":[],"mappings":"AAEA,gBACE,8BAA8B,AAC9B,6BAA6B,AACzB,uBAAuB,AACnB,kBAAmB,CAoB5B,AAxBD,2BAMI,8BAA8B,AAC9B,8BAA8B,AAC1B,+BAA+B,AAC3B,0BAA2B,CAIpC,AAbH,sCAWM,gBAAiB,CAClB,AAZL,uCAgBM,eAAgB,CACjB,AAjBL,2BAqBQ,QAAS,CACZ","file":"SlideWithImage.m.scss","sourcesContent":["@import '~scss/variables';\n\n.SlideWithImage {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  &.left-image {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: reverse;\n        -ms-flex-direction: row-reverse;\n            flex-direction: row-reverse;\n    & .slide-img {\n      margin-right: 4em;\n    }\n  }\n  &.right-image {\n    & .slide-img {\n      margin-left: 4em;\n    }\n  }\n  .slide {\n    &-img {\n        margin: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1131);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("34fb24b4", content, true, {});

/***/ })

});


// WEBPACK FOOTER //
// static/js/86.4abec71d38bab18dda11.js